import React from "react";

/**
 * Kabul edilen / devam eden randevu kartı.
 * Her kartta "Sırayı Tamamla" butonu ile işlem sonlandırılabilir.
 */
export default function StaffAppointmentCard({
  appointment,
  onComplete,
  completeLoading,
}) {
  if (!appointment) return null;

  return (
    <div className="staff-appointment-card">
      <p>
        <strong>Sıra no:</strong> {appointment.queueNumber}
      </p>
      <p>
        <strong>İsim:</strong> {appointment.user?.name}
      </p>
      <p>
        <strong>Telefon:</strong> {appointment.user?.phone}
      </p>
      <p>
        <strong>Şube:</strong> {appointment.branch?.name}
      </p>
      <div className="staff-complete-actions">
        <button
          type="button"
          className="staff-complete-btn"
          onClick={() => onComplete(appointment)}
          disabled={completeLoading}
        >
          {completeLoading ? "Tamamlanıyor..." : "Sırayı Tamamla"}
        </button>
      </div>
    </div>
  );
}
